<template>
    <div class="container">

        <div class="card ">
            <div class="card-header bg-info-light">
                Naujas įvykis
            </div>
            <div class="card-body">
                <!--<div class="form-row">-->
                <!--<div class="col-12 col-md-6">-->
                <!--<label for="eq_id">Įranga</label>-->
                <!--<v-select v-if="equipment" class="vue-select2s" id="eq_id" name="select2"-->
                <!--:options="equipment" label="name"-->
                <!--:model.sync="new_equipment"-->
                <!--v-model="new_equipment"-->
                <!--:searchable="true" language="en-US">-->
                <!--</v-select>-->
                <!--</div>-->
                <!--<div class="col-6 col-md-3">-->
                <!--<label for="eq_qty">Kiekis</label>-->
                <!--<input id="eq_qty" class="form-control" @keyup="enter_submit" v-model="new_equipment_qty" type="text">-->
                <!--</div>-->
                <!--<div class="col-6 col-md-3">-->
                <!--<label for="">&nbsp;</label>-->
                <!--<button @click="add_equipment_to_offer" class="form-control btn btn-outline-success">Pridėti</button>-->
                <!--</div>-->
                <!--</div>-->
            </div>
            <div class="card-body">
                <!--<div class="form-row" v-for="(se, i) in selected_equipment">-->
                <!--<div @click="deleteSelected(i, se.price, se.quantity)" class="col-1">-</div>-->
                <!--<div class="col-11 col-md-6">{{ se.equipment_text }} &#45;&#45; {{ se.quantity }} vnt.</div>-->
                <!--</div>-->
                <div class="form-row">
                    <div class="col-3">
                        <div class="form-group">
                            <label for="date_start">Nuo</label>
                            <div class="input-group">
                                <input id="date_start" class="form-control" type="text" v-model="date_start">
                                <!--<div class="input-group-append">-->
                                <!--<div class="input-group-text">€</div>-->
                                <!--</div>-->
                            </div>

                        </div>
                    </div>
                    <div class="col-3">
                        <div class="form-group">
                            <label for="date_end">Iki</label>
                            <div class="input-group">
                                <input id="date_end" class="form-control" type="text" v-model="date_end">
                                <!--<div class="input-group-append">-->
                                <!--<div class="input-group-text">€</div>-->
                                <!--</div>-->
                            </div>

                        </div>
                    </div>
                </div>


                <div class="form-row">
                    <div class="col-3">
                        <div class="form-group">
                            <label for="comment">Komentaras</label>
                            <div class="input-group">
                                <input id="comment" class="form-control" type="text" v-model="comment">
                                <!--<div class="input-group-append">-->
                                <!--<div class="input-group-text">€</div>-->
                                <!--</div>-->
                            </div>

                        </div>
                    </div>
                </div>
                <div class="form-row">
                    <div class="col-3">
                        <!--<div class="form-group">-->
                        <label for="cust_id">Klientas</label>
                        <!--<div class="input-group">-->
                        <v-select v-if="customers" class="" id="cust_id" name="select2"
                                  :options="customers" label="name"
                                  :model.sync="selected_customer"
                                  v-model="selected_customer"
                                  :searchable="true" language="en-US">
                        </v-select>
                        <!--</div>-->

                        <!--</div>-->
                    </div>
                </div>

                <div class="form-row" v-if="!selected_customer">
                    <div class="col-6 col-md-3">
                        <label for="contact_address">Adresas</label>
                        <input id="contact_address" class="form-control" v-model="contact_address"
                               type="text">
                    </div>
                    <div class="col-6 col-md-3">
                        <label for="contact_name">Vardas</label>
                        <input id="contact_name" class="form-control" v-model="contact_name"
                               type="text">
                    </div>
                    <div class="col-6 col-md-3">
                        <label for="contact_phone">Tel.</label>
                        <input id="contact_phone" class="form-control" v-model="contact_phone"
                               type="text">
                    </div>
                </div>


            </div>
            <div class="card-footer">
                <button @click="store_event" class="btn btn-outline-success">Sukurti</button>
            </div>
        </div>
    </div>
</template>

<script>
    import vSelect from 'vue-select';


    export default {
        name: "NewEvent",

        props: ['uid'],
        components: {
            vSelect,
        },
        data() {
            return {
                start: '',
                customer_id: '',
                date_start: '',
                date_end: '',
                comment: '',
                contact_address: '',
                contact_name: '',
                contact_phone: '',
                equipment: '',
                new_equipment: '',
                new_equipment_qty: '',
                user_id: '',
                customers: '',
                selected_customer: ''
            }
        },
        watch: {},
        mounted() {

            this.date_start = this.$attrs.start;

            axios.get('/get_equipment').then(res => {
                this.equipment = res.data
            });
            axios.get('/get_customers').then(res => {
                this.customers = res.data
            });

            var self = this;
            var a_moths = ["Sausis", "Vasaris", "Kovas", "Balandis", "Gegužė", "Birželis", "Liepa", "Rugpjūtis", "Rugsėjis", "Spalis", "Lapkritis", "Gruodis"];
            var a_day_min = ["Sk", "Pr", "An", "Tr", "Kt", "Pn", "Še"];
            $('#date_start').datepicker({
                    firstDay: 1,
                    dateFormat: "yy-mm-dd",
                    monthNames: a_moths,
                    dayNamesMin: a_day_min,
                    // showOn: "both"
                    onSelect: function (dateText) {
                        self.date_start = this.value;
                    }
                }
            );
            $('#date_end').datepicker({
                    firstDay: 1,
                    dateFormat: "yy-mm-dd",
                    monthNames: a_moths,
                    dayNamesMin: a_day_min,
                    // showOn: "both"
                    onSelect: function (dateText) {
                        self.date_end = this.value;
                    }
                }
            );

        },
        created() {

        },
        methods: {
            add_equipment_to_offer() {
                this.selected_equipment.push({
                    equipment_id: this.new_equipment.id,
                    equipment_text: this.new_equipment.name,
                    quantity: this.new_equipment_qty,
                    price: this.new_equipment.price
                });
                this.price = Number(this.price) + (Number(this.new_equipment.price) * Number(this.new_equipment_qty));
                // this.percent1 = this.percent3 = '';
                console.log(this.new_equipment.power);
                // if(this.new_equipment.power > 0 && this.new_equipment.equipment_type_id == 1){
                //     this.power = Number(this.power) + Number(this.new_equipment.power) * Number(this.new_equipment_qty);
                //     this.power  = this.power.toFixed(2);
                // }
                this.new_equipment_qty = '';
            },
            deleteSelected(i, price, quantity) {
                this.selected_equipment.splice(i, 1);
                this.price = Number(this.price) - (Number(price) * Number(quantity));
            },
            store_event() {
                console.log(this._data);
                // if(this.selected_customer.length == 0){ alert('Nėra kliento'); return; }
                //
                // this.total = Number(this.price) - Number(this.discount);
                // this.customer_id = 1;
                // this.user_id = this.$props.uid;
                // this.customer_id = this.selected_customer.id;
                // this.percent2 = (100 - this.percent1 - this.percent3);
                axios.post('/store_event', this._data).then(res => {
                    console.log(res.data);
                    window.location.href = '/events';
                })
            },

            enter_submit(e) {
                if (e.keyCode == 13) {
                    console.log('enter');
                    this.add_equipment_to_offer();
                }

            }
        }
    }
</script>

<style scoped>

</style>